import { createSelector } from 'reselect'
import { nvqualStatusSourceSelector } from 'containers/Project/NvqualSection/selectors'
import { STATUS_DROPDOWN_ORDER, PENDING } from 'containers/Project/NvqualSection/constants'
import * as R from 'ramda'

const statusSelector = (state) => state.project.projectNvqual.edit.revisionStatus
const commentSelectorRaw = (state) => state.project.projectNvqual.edit.comment
const revisionNameSelectorRaw = (state) => state.project.projectNvqual.edit.revisionName

const commentSelector = createSelector(
  commentSelectorRaw,
  (comment) => comment == undefined || comment == null ? '' : comment
)

const revisionNameSelector = createSelector(
  revisionNameSelectorRaw,
  (name) => name ? name : ''
)

const nvqualStatusSourceDropdownSelector = createSelector(
  nvqualStatusSourceSelector,
  (sourceList) => STATUS_DROPDOWN_ORDER.map((s) => {
    const { label, value } = sourceList.find(({label}) => label === s)
    return { label, value, disabled: s === PENDING }
  })
)

export {
  statusSelector,
  commentSelector,
  revisionNameSelector,
  nvqualStatusSourceDropdownSelector
}
